import { createContext, useContext } from 'react'
import type { LegalDocument, OrgContext } from '@/shared/domain'
import type { RevokeImpersonation } from '@/modules/auth/use-cases'

export type OrgContextValue = OrgContext & {
  selectOrg: (orgId: string | null) => void
  isLoading: boolean
  loadFailed?: boolean
  refresh?: () => Promise<void>
  userDisplayName?: string | null
  pendingLegalDocuments: LegalDocument[]
  isImpersonating?: boolean
  impersonationOrgName?: string | null
  impersonationExpiresAt?: string | null
  stopImpersonation?: RevokeImpersonation
}

export const OrgContextCtx = createContext<OrgContextValue | null>(null)

export function useOrgContext(): OrgContextValue {
  const value = useContext(OrgContextCtx)
  if (!value) throw new Error('useOrgContext must be used within <PersonaProvider>')
  return value
}
